import { resolveHomeLandingModeFromPath } from "../../utils/homeLandingRoutes";

// Allow exact browse routes, never a broad /explore or /stays-camps prefix:
// those prefixes also contain destination, camp and experience detail pages.
const FLOATING_ROUTES = new Set([
  "/home/explore",
  "/explore",
  "/destination",
  "/destinations",
  "/districts",
  "/stays-camps",
  "/experiences",
  "/jungle-safaris",
  "/cruise-boating",
  "/treks-trails",
  "/track-trails",
  "/explore/districts",
  "/explore/experiences",
  "/explore/jungle-safari",
  "/explore/cruise-boating",
  "/explore/treks-trails",
  "/explore/track-trails",
]);

export const resolveQuickBookPlacement = (pathname = "/") => {
  const path = String(pathname || "/").split(/[?#]/)[0].replace(/\/+$/, "") || "/";
  const homeMode = resolveHomeLandingModeFromPath(path);
  if (homeMode === "stays" || homeMode === "experiences") return "home";
  if (FLOATING_ROUTES.has(path) || /^\/(?:explore\/)?district\/[^/]+$/.test(path)) {
    return "floating";
  }
  return null;
};
